import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop() {
  return (
    <ul className="hidden w-full items-center justify-end overflow-visible lg:flex gap-6 xl:gap-10">
      <HeaderMenu />
    </ul>
  )
}
